import { useEffect } from 'react';
import type React from 'react';

import { Alert } from '@change/ds-core-ui';

import { useI18n } from '@change-corgi/core-react/i18n';

import { Html } from '#src/app/shared/components/html';

type Props = {
	onDismiss?: () => void;
	onView?: () => void;
	onLinkClick?: () => void;
	copy: Readonly<{ body: string }>;
};

export const TermsOfServiceBanner: React.FC<Props> = ({ onDismiss, copy, onView, onLinkClick }) => {
	const { translate } = useI18n();
	useEffect(() => {
		onView?.();
	}, [onView]);
	return (
		<Alert
			variant="info"
			type="page"
			onDismissClick={onDismiss}
			dismissButtonAriaLabel={translate('corgi.components.banner.close')}
		>
			<Html html={copy.body} onClickLink={onLinkClick} />
		</Alert>
	);
};
